// Same shape as DocumentIcon, but stroke="currentColor" instead of a
// hardcoded white -- DocumentIcon's paths assume a dark/colored background
// (nav bar, print modal), so it can't be recolored for use on a plain white
// menu row without risking those existing call sites.
export const DocumentOutlineIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.8333 12.6721V19.8333C14.8333 20.8458 14.0396 21.6667 13.0437 21.6667H5.29167C4.29375 21.6667 3.5 20.8458 3.5 19.8333V8.83333C3.50284 8.34798 3.69691 7.88331 4.04011 7.54011C4.38331 7.19691 4.84798 7.00284 5.33333 7H9.255C9.39074 7.00021 9.52509 7.02743 9.6502 7.08008C9.77532 7.13273 9.8887 7.20975 9.98375 7.30667L14.5317 11.9317C14.7252 12.1295 14.8335 12.3953 14.8333 12.6721Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.33333}
    />
    <path
      d="M9.16602 7V11.5C9.16969 11.8083 9.29379 12.1029 9.51179 12.3209C9.72979 12.5389 10.0244 12.663 10.3327 12.6667H14.8327"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.33333}
    />
    <path
      d="M8.16602 7V4.83333C8.16886 4.34798 8.36293 3.88331 8.70613 3.54011C9.04933 3.19691 9.514 3.00284 9.99935 3H13.916C14.0525 3.00019 14.1876 3.02738 14.3135 3.08002C14.4395 3.13265 14.5537 3.20968 14.6498 3.30667L19.1977 7.93167C19.391 8.12745 19.4994 8.39152 19.4993 8.66667V15.8333C19.4993 16.8458 18.7056 17.6667 17.7098 17.6667H15.166"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.33333}
    />
    <path
      d="M13.834 3V7.5C13.8377 7.80828 13.9618 8.10289 14.1798 8.32089C14.3978 8.53889 14.6924 8.66299 15.0007 8.66667H19.5007"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.33333}
    />
  </svg>
);
